<script>
  export let content;
  export let link;
  export let icon = null;

  import Text from "./Text.svelte";
  import Icon from "../helpers/Icon.svelte";
</script>

<div class="locked-link">
  <a href={link} target="_blank">
    {#if icon}<Icon style="margin-right: 0.5rem;" src={icon} />{/if}
    {#if content}
      <Text {content} style="text-align: center; display: inline-block;" />
    {/if}
  </a>
</div>

<style>
  .locked-link a {
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }
</style>
